import {
  Box,
  Divider,
  List,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Stack,
  styled,
} from "@mui/material";
import { COLOR_CONSTANTS } from "@/helpers/Colors";
import type { StatusCounts } from "../types/common";
import { getFilterCount, getSidebarFilters } from "../constants/sidebarFilters";

const CustomListItem = styled(ListItemButton)`
  &&.Mui-selected {
    color: ${COLOR_CONSTANTS["on-primary/variant"]};
    background-color: ${COLOR_CONSTANTS["primary/variant"]};
  }
`;

interface StatusFilterSidebarProps {
  isInternal: boolean;
  statusCounts: StatusCounts;
  totalCount: number;
  selectedStatus: string | null;
  onStatusChange: (status: string | null) => void;
}

export default function StatusFilterSidebar({
  isInternal,
  statusCounts,
  totalCount,
  selectedStatus,
  onStatusChange,
}: StatusFilterSidebarProps) {
  const filters = getSidebarFilters(isInternal);

  return (
    <Box
      sx={{
        width: 250,
        bgcolor: "background.paper",
        borderRadius: "8px",
        flexShrink: 0,
        maxHeight: "calc(100vh - 180px)",
        overflowY: "auto",
      }}
    >
      <List component="nav">
        <ListSubheader>INVOICES</ListSubheader>
        <Divider />
        {filters.map((filter) => {
          const count = getFilterCount(filter, statusCounts, totalCount);

          return (
            <CustomListItem
              key={filter.label}
              selected={selectedStatus === filter.status}
              onClick={() => onStatusChange(filter.status)}
            >
              <ListItemText
                primary={
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <div>{filter.label}</div>
                    <div>{count}</div>
                  </Stack>
                }
              />
            </CustomListItem>
          );
        })}
      </List>
    </Box>
  );
}
